import _toConsumableArray from "C:/Users/amirs/Documents/Projects/top-menu-panel/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import { ArrayToJson } from "../../helpers/array";
import providerApiService from "../../services/api/ProviderApiService";
export default {
  name: "HourModal",
  data: function data() {
    var timespan = this.timespan.hour.length > 0 ? _toConsumableArray(this.timespan.hour) : [{
      from: "",
      to: ""
    }];
    return {
      hours: _toConsumableArray(timespan)
    };
  },
  components: {},
  methods: {
    save: function save() {
      var _this = this;

      var data = this.data.filter(function (item) {
        return item.hour.length > 0;
      });
      var newData = this.hours.length > 0 ? [{
        day: this.timespan.day,
        hour: this.hours
      }] : null;
      var currentIndex = data.findIndex(function (item) {
        return item.day === _this.timespan.day;
      });

      if (currentIndex >= 0) {
        data[currentIndex].hour = this.hours;
      } else {
        data = [].concat(_toConsumableArray(data), _toConsumableArray(newData));
      }

      data.sort(function (a, b) {
        return a.day - b.day;
      });
      this.$vs.loading();
      providerApiService.submitProviderHours(this.currentProvider.id, ArrayToJson(data), this.hourId).then(function (result) {
        _this.$vs.notify({
          text: "عملیات با موفقیت انجام شد.",
          color: "success",
          position: "bottom-center"
        });

        _this.$emit("timeConfiremd", _this.hours, result.resource.id);
      }).catch(function (err) {
        _this.$vs.notify({
          text: err.getErrorDescriptions(),
          color: "danger",
          position: "bottom-center"
        });
      }).finally(function () {
        _this.$vs.loading.close();
      });
    },
    addTimespan: function addTimespan() {
      this.hours.push({
        from: "",
        to: ""
      });
    },
    removeItem: function removeItem(index) {
      this.hours.splice(index, 1);
    }
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider"
  }),
  watch: {},
  props: {
    timespan: {
      required: false,
      type: Object
    },
    data: {
      required: false,
      type: Array
    },
    hourId: {
      required: false,
      type: Number
    }
  }
};